var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouth1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53.2 22.1",
    style: {
      enableBackground: "new 0 0 53.2 22.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF6563;}\n\t.st1{fill:#DC3F57;}\n\t.st2{fill:#842751;}\n\t.st3{opacity:0.6;fill:#D177B8;}\n\t.st4{fill:#FFFCB8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.8,11.6c0,0,7.5,6.9,23.1,6.9c15.6,0,24.3-6.6,24.3-6.6s-12-5.2-24.3-5.2C13.1,6.6,2.8,11.6,2.8,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.2,10.5c0,0,7.2-10.5,21.4-10.5c11.4,0,23.6,11.8,23.6,11.8s-2.6-0.9-7.2-1.8c-4.6-0.9-13.7-3.7-19.4-3 C18,7.5,10.2,10.5,5.2,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.6,5.4C11.7,5.4,0,13.5,0,13.5s13.1-6.1,26.6-6.1c14,0,26.5,6,26.5,6S39.4,5.4,26.6,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.3,9.2c0,0,3.4-8.7,17.8-8.7s19.1,9.1,19.1,9.1l5,2.2c0,0-11-11.8-24.1-11.8C12.7,0,5.2,10.5,5.2,10.5 L8.3,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.3,15.1c0,0,8,7,18.3,7c10.4,0,19.5-8,19.5-8s-9.5,4.3-20.3,4.3S8.3,15.1,8.3,15.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "33.1,10.2 35.4,14.1 37.6,13.5 34.7,10.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth1);
export default __webpack_public_path__ + "static/media/Mouth1.10251038ce8ceed5d062cb90e88213f2.svg";
export { ForwardRef as ReactComponent };